export default {
  MODAL_SET_DATA: 'MODAL_SET_DATA',
  MODAL_SET_OPEN: 'MODAL_SET_OPEN',
  MODAL_SET_CLOSE: 'MODAL_SET_CLOSE',
  APPLICATION_SET_ID: 'APPLICATION_SET_ID',
};
